module.exports = __webpack_public_path__ + "img/logo.b359c7ce.png";